import type { DashboardTab } from '@/features/dashboard/types';

/** Decodes a URL-encoded route param, returning empty string if absent. */
export const decodeRouteParam = (param: string | undefined): string =>
  param ? decodeURIComponent(param) : '';

/**
 * Returns the URL to the first tab of the first dashboard in `data`,
 * or null if the data is empty.
 */
export const getFirstDashboardTabPath = (data: Record<string, DashboardTab>): string | null => {
  const firstDashboard = Object.keys(data)[0];
  if (!firstDashboard) return null;
  const firstTab = Object.keys(data[firstDashboard])[0];
  if (!firstTab) return null;
  return `/dashboard/${encodeURIComponent(firstDashboard)}/${encodeURIComponent(firstTab)}`;
};

/**
 * Given a list of tab names and a desired tab param, returns the resolved
 * tab index and the canonical URL redirect path (if the param is missing or
 * doesn't match a tab). Returns null for path when the tab was found exactly.
 */
export const resolveTabSelection = (
  dashboardName: string,
  tabNames: string[],
  decodedTabParam: string
): { tabIndex: number; redirectPath: string | null } => {
  if (!decodedTabParam || !tabNames.includes(decodedTabParam)) {
    const redirectPath =
      tabNames.length > 0
        ? `/dashboard/${encodeURIComponent(dashboardName)}/${encodeURIComponent(tabNames[0])}`
        : null;
    return { tabIndex: 0, redirectPath };
  }
  return { tabIndex: tabNames.indexOf(decodedTabParam), redirectPath: null };
};
